module.exports = __webpack_public_path__ + "img/jrtticon.41104888.svg";